import { useEffect, useState } from "react";
import StringHelpers from "../../../utilities/stringHelpers";
import formUtilities from "../../../utilities/formUtilities";
import { SearchSelect } from "../../shared/searchSelect";
import Api from "../../api/api";
import arrayUtilities from "../../../utilities/arrayUtilities";
import Enums from "../../../utilities/enum";
import { TagSelector } from "../../shared/tagSelector";

export const FormSiteGeneralDetails = ({ name, setName, allTags, selectedTags, updateTag, siteCode, setSiteCode, permitPrefix, setPermitPrefix, contractExpiry, setContractExpiry, status, setStatus, allowCancellationOfBreaches, setAllowCancellationOfBreaches, maximumCancellationsPerMonth, setMaximumCancellationsPerMonth, enableAutoAssignUser, setEnableAutoAssignUser, autoAssignedUser, setAutoAssignUser, isNew, jurisdiction, setJurisdiction, addressLine1, setAddressLine1, addressLine2, setAddressLine2, addressLine3, setAddressLine3, townOrCity, setTownOrCity, postCode, setPostCode, users, vehicleAnalyticsEnabled, setVehicleAnalyticsEnabled, preventDuplicateBreaches, setPreventDuplicateBreaches, regionId, setRegionId, debtCollectionProviderId, setDebtCollectionProviderId, organisationId, token }) => {
    const [regions, setRegions] = useState(null)
    const [debtCollectionProviders, setDebtCollectionProviders] = useState(null);
    
    const getRegions = () => {
        Api.getRegions(
            data => setRegions(data),
            error => console.log(error),
            organisationId,
            token
        )
    }
    const getDebtCollectionProviders = () => {
        Api.getDebtCollectionProviders(
            (data) => {
                setDebtCollectionProviders(data)
            },
            (error) => {
                console.log(error)
            },
            organisationId,
            token
        )
    };
    useEffect(() => {
        getRegions()
        getDebtCollectionProviders()
    }, [])

    const defaultCollectionProvider = debtCollectionProviders?.find(item => item.isDefault)

    const defaultDebtCollectionProviderLabel = defaultCollectionProvider !== undefined && defaultCollectionProvider !== null
    ? `Default (${ defaultCollectionProvider.name })`
    : "Default"

    return (
        <>
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Name<span className="req"></span></p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input required className="form-control mb-0" type="text" value={ name } onChange={ (e) => {
                            setName(e.target.value);
                            formUtilities.requiredField(e.target.parentNode, e.target.value)
                        } } />
                        <small className='invalid-feedback text-danger'>Please enter a site name</small>
                    </div>
                </div>
            </div>
            {!arrayUtilities.isNullOrEmpty(regions) && <div className="row align-items-center mb-1">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Region</p>
                </div>
                <div className=" col-md-6 col-12">
                    <SearchSelect 
                        onSelect={value => setRegionId(!StringHelpers.isNullOrEmpty(value) ? value : null)}
                        options={[{value: "", label: "None"}, ...regions.map(item => ({value: item.id, label: item.name}))]}
                        selected={!StringHelpers.isNullOrEmpty(regionId) ? regionId : null}
                        width="100%"
                        defaultLabel='None'
                    />
                </div>
            </div>}
            {!arrayUtilities.isNullOrEmpty(debtCollectionProviders) && 
            <div className="row align-items-center mb-1">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Debt Collection Provider</p>
                </div>
                <div className="d-flex align-items-center col-md-6 col-12">
                    <SearchSelect 
                        onSelect={value => setDebtCollectionProviderId(!StringHelpers.isNullOrEmpty(value) ? value : null)}
                        options={
                            [
                                {value: "", label: defaultDebtCollectionProviderLabel}, 
                                ...debtCollectionProviders.map(item => ({value: item.id, label: item.name}))
                            ]
                        }
                        selected={!StringHelpers.isNullOrEmpty(debtCollectionProviderId) ? debtCollectionProviderId : null}
                        width="100%"
                        defaultLabel={defaultDebtCollectionProviderLabel}
                    />
                    <button onClick={() => setDebtCollectionProviderId("") } type="button" className="btn btn-sm m-0 ml-2 px-2 text-nowrap btn-falcon-default">
                        <i className='fas fa-undo mr-1'></i>Reset to default
                    </button>
                </div>
            </div>}
            { !arrayUtilities.isNullOrEmpty(allTags) && <div className="row mb-1">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Tags</p>
                </div>
                <div className=" col-md-6 col-12">
                    { isNew ? <p className="font-weight-semi-bold mb-1 text-left">You will be able to add tags once the site has been created.</p>
                        : <TagSelector 
                            selectedTags={selectedTags}
                            tags={allTags}
                            width="100%"
                            isClearable={false}
                            onChange={
                                (tagSelections, lastIdAmended) => {
                                    if (tagSelections.includes(lastIdAmended)) {
                                        updateTag(true, lastIdAmended)
                                    } else {
                                        updateTag(false, lastIdAmended)
                                    }
                                }
                            }
                        />
                    }
                </div>
            </div> }
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Site Code<span className="req"></span></p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input required className="form-control mb-0" type="text" value={ siteCode } onChange={ (e) => {
                            setSiteCode(e.target.value)
                            formUtilities.requiredField(e.target.parentNode, e.target.value)
                        } } />
                        <small className='invalid-feedback text-danger'>Please enter a site code</small>
                    </div>
                </div>
            </div>

            { !isNew && <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Permit Prefix<span className="req"></span></p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input required className="form-control mb-0" type="text" value={ permitPrefix } onChange={ (e) => {
                            setPermitPrefix(e.target.value)
                            formUtilities.requiredField(e.target.parentNode, e.target.value)
                        } } />
                        <small className='invalid-feedback text-danger'>Please enter a permit prefix</small>
                    </div>
                </div>
            </div> }
            <div className="row align-items-center">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Contract Expiry</p>
                </div>
                <div className=" col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="date" value={ StringHelpers.isNullOrEmpty(contractExpiry) ? null : contractExpiry.substring(0, 10) } onChange={ (e) => setContractExpiry(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row align-items-center mb-1">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Allowing cancelling of breaches</p>
                </div>
                <div className="col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="allow-cancellation-of-breaches" checked={ allowCancellationOfBreaches } onChange={ (e) => {
                        if (!e.target.checked) {
                            setMaximumCancellationsPerMonth("")
                        }
                        setAllowCancellationOfBreaches(e.target.checked)
                    } } />
                    <label className="custom-control-label custom-toggle ml-3" htmlFor="allow-cancellation-of-breaches"></label>
                    { allowCancellationOfBreaches && <>Yes</> }{ !allowCancellationOfBreaches && <>No</> }
                </div>
            </div>
            {
                allowCancellationOfBreaches &&
                    <div className="row align-items-center">
                        <div className=" col-md-3 col-12 ">
                            <p className="font-weight-semi-bold mt-1 mb-1">Maximum Cancellations Per Month</p>
                        </div>
                        <div className=" col-md-6 col-12">
                            <div className="form-group mb-1">
                                <input className="form-control mb-0" type="number" value={ maximumCancellationsPerMonth } onChange={ (e) => setMaximumCancellationsPerMonth(e.target.value) } />
                            </div>
                        </div>
                    </div>
            }
            <div className="row align-items-center mb-1">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Auto-assign breaches to a user</p>
                </div>
                <div className="col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="enable-auto-assign-user" checked={ enableAutoAssignUser } onChange={ (e) => {
                        if (!e.target.checked) {
                            setAutoAssignUser("")
                        }
                        setEnableAutoAssignUser(e.target.checked)
                    } } />
                    <label className="custom-control-label custom-toggle ml-3" htmlFor="enable-auto-assign-user"></label>
                    { enableAutoAssignUser && <>Yes</> }{ !enableAutoAssignUser && <>No</> }
                </div>
            </div>
            {
                enableAutoAssignUser && users &&
                    <div className="row align-items-center mb-1">
                        <div className=" col-md-3 col-12 ">
                            
                        </div>
                        <div className=" col-md-6 col-12">
                            <SearchSelect 
                                onSelect={value => setAutoAssignUser(!StringHelpers.isNullOrEmpty(value) ? value : null)}
                                options={[{value: "", label: "None"}, ...users.map(item => ({value: item.id, label: `${item.firstName} ${item.lastName}`}))]}
                                selected={!StringHelpers.isNullOrEmpty(autoAssignedUser) !== null ? autoAssignedUser : null}
                                width="100%"
                                defaultLabel='None'
                            />
                        </div>
                    </div>
            }
            <div className="row align-items-center mb-2">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Status</p>
                </div>
                <div className=" col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="site-status" checked={ status } onChange={ () => setStatus(!status) } />
                    <label className="custom-control-label ml-3 custom-toggle" htmlFor="site-status"></label>
                    { status && <>Active</> }{ !status && <>Deactivated</> }
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Vehicle Analytics</p>
                </div>
                <div className=" col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="site-vehicle-analytics" checked={ vehicleAnalyticsEnabled } onChange={ () => setVehicleAnalyticsEnabled(!vehicleAnalyticsEnabled) } />
                    <label className="custom-control-label ml-3 custom-toggle" htmlFor="site-vehicle-analytics"></label>
                    { vehicleAnalyticsEnabled && <>Enabled</> }{ !vehicleAnalyticsEnabled && <>Disabled</> }
                </div>
            </div>
            <div className="row align-items-center mb-2">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mt-1 mb-1">Prevent Duplicate Breaches</p>
                </div>
                <div className=" col-md-6 col-12 custom-control custom-switch">
                    <input className="custom-control-input" type="checkbox" id="site-prevent-duplicate-breaches" checked={ preventDuplicateBreaches } onChange={ () => setPreventDuplicateBreaches(!preventDuplicateBreaches) } />
                    <label className="custom-control-label ml-3 custom-toggle" htmlFor="site-prevent-duplicate-breaches"></label>
                    { preventDuplicateBreaches && <>Enabled - one breach per VRM and contravention per day</> }{ !preventDuplicateBreaches && <>Disabled</> }
                </div>
            </div>
            <hr className="border-dashed border-bottom-0"></hr>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Address Line 1<span className="req"></span></p>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input required className="form-control mb-0" type="text" value={ addressLine1 } onChange={ (e) => {
                            setAddressLine1(e.target.value);
                            formUtilities.requiredField(e.target.parentNode, e.target.value);
                        }} />
                        <small className='invalid-feedback text-danger'>Please enter the first line of the address</small>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Address Line 2</p>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="text" value={ addressLine2 } onChange={ (e) => setAddressLine2(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Address Line 3</p>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input className="form-control mb-0" type="text" value={ addressLine3 } onChange={ (e) => setAddressLine3(e.target.value) } />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Town or City<span className="req"></span></p>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input required className="form-control mb-0" type="text" value={ townOrCity } onChange={ (e) => {
                            setTownOrCity(e.target.value);
                            formUtilities.requiredField(e.target.parentNode, e.target.value);
                        } } />
                        <small className='invalid-feedback text-danger'>Please enter a town or city</small>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Post Code<span className="req"></span></p>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group mb-1">
                        <input required className="form-control mb-0" type="text" value={ postCode } onChange={ (e) => {
                            setPostCode(e.target.value)
                            formUtilities.requiredField(e.target.parentNode, e.target.value);
                        } } />
                        <small className='invalid-feedback text-danger'>Please enter a postcode</small>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className=" col-md-3 col-12 ">
                    <p className="font-weight-semi-bold mb-1">Jurisdiction</p>
                </div>
                <div className="col-md-6 col-12">
                    <div className="form-group mb-1">
                        <select value={jurisdiction} onChange={e => setJurisdiction(e.target.value)} className="form-control">
                            {
                                Object.entries(Enums.Jurisdiction)
                                .map(([key, value]) => 
                                    <option key={key} value={key}>{value}</option>
                                )
                            }
                        </select>
                    </div>
                </div>
            </div>
        </>
    )
}